import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-delete-dialog',
  templateUrl: './popup-delete-dialog.component.html',
  styleUrls: ['./popup-delete-dialog.component.scss']
})
export class PopupDeleteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
